import {mapFilters} from '@/utils/helpers';
const initState = () => ({
  creditCreatingInProgress: false
})

export const state = initState
export const getters = {
}
export const mutations = {
  setCreditCreatingInProgress(state, inProgress){
    state.creditCreatingInProgress = inProgress
  }
}

export const actions = {
  async fetchCustomerCredits({commit},{filters,pagingInfo}){
    let resultArray = [];
    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.post(`webpos/customer-credit`,filter);
      if (result.data.hasErrors){
        this.$toast.error("Error while getting customer credits");
        return resultArray
      }
      resultArray = result.data;
    }
    catch(e){
      this.$toast.error("Error while getting customer credits");
    }
    return resultArray

  },
  async getCustomerCreditItems({ commit }, { memoID, filters }) {
    let resultArray = [];
    try {
      const queryString = new URLSearchParams(filters).toString();
      let result = await this.$axios.get(`webpos/customer-credit/${memoID}/items?${queryString}`);

      if (result.data.hasErrors) {
        this.$toast.error("Error while getting customer credit items!");
      } else {
        resultArray = result.data.value;
      }
    } catch (e) {
      this.$toast.error("Error while getting customer credit items!");
    }
    return resultArray;
  },

  async getCustomerInvoicesForCustomerCredits({commit},{pagingInfo, filters}){
    let resultArray = [];
    let url = `webpos/customer-credit/invoice-items/?customerID=${filters.customerID}&pageNo=${pagingInfo.pageNo}&pageSize=${pagingInfo.pageSize}`
    try{
      if(filters.storeID > 0){
        url =`${url}&storeID=${filters.storeID}`
      }
      let result = await this.$axios.get(url);
      if (result.data.hasErrors){
        this.$toast.error("Error while getting customer invoice items!");
      }
      else
      {
        resultArray =  result.data.value;
      }
    }
    catch(e){
      this.$toast.error("Error while getting customer invoice items!");
    }
    return resultArray;
  },
  async createNewCustomerCredit({commit},{customerCredit}){
    let resultData;
    try{
      commit('setCreditCreatingInProgress', true)
      const result = await this.$axios.post(`webpos/customer-credit/create-customer-credit`, customerCredit);
      if (result.data.hasErrors){
        this.$toast.error("Error while creating customer credit!");
        return;
      }
      if (result.data.value.id > 0){
        this.$toast.success("Customer credit created successfully!");
      }
      resultData = result.data
    }
    catch(error){
      this.$toast.error('Error while creating new customer credit.');
    }
    finally {
      commit('setCreditCreatingInProgress', false)
    }
    return resultData;
  },

  async refundCustomerCredit({commit},{refund}){
    try{
      const result = await this.$axios.$post(`webpos/customer-credit/refund`, refund);
      if (result?.hasErrors){
        const messages = (result.errorMessages || []).map(e => e.value)
        this.$toast.error(messages.length ? messages.join(' ') : this.$i18n.t('error_processing_payout'))
        return false
      }
      return true
    }
    catch(e){
      this.$toast.error(this.$i18n.t('error_processing_payout'))
      return false
    }
  },

}

